import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";

const logs = [
  {
    ts: "2026.01 – Present",
    tag: "ACTIVE",
    org: "UF Health // IT Systems Security Analyst",
    body: "Enterprise IT governance across clinical and academic systems. Author security policies, standards, and baselines aligned with NIST CSF, NIST 800-53, and HIPAA Security Rule. Run structured risk assessments, control validation, and audit-readiness work. Partner with cross-functional teams to translate compliance requirements into operational controls, and support incident-response planning and user security awareness.",
  },
  {
    ts: "2025.04 – 2026.01",
    tag: "SHIPPED",
    org: "LOG(N) Pacific // Cyber Security Analyst",
    body: "Automated PowerShell remediations and Tenable-driven vulnerability scans that eliminated all critical/high risks and reduced medium vulnerabilities by 76% across endpoints. Ran DISA STIG-based secure configuration audits aligned with NIST 800-53. Led EDR threat hunts uncovering ransomware, brute-force, and data-exfiltration activity. Built custom Microsoft Defender for Endpoint rules that automated containment and cut response time by 33%. Used KQL to slice SIEM/EDR data for detection and investigation.",
  },
  {
    ts: "2022.03 – 2026.01",
    tag: "SHIPPED",
    org: "University of Florida // Network Technician",
    body: "Tier-1 network support across a large university footprint. Managed 1,000+ university assets with 100% compliance to UF and state regulations. Cut inventory discrepancies by 15% and safeguarded $250K+ in property value through annual reviews and surplus reconciliation. Kept audit-ready records with departmental stakeholders — 30% faster reporting. Escalated complex issues to engineering; documented network installations and system changes; translated technical detail for non-technical users.",
  },
  {
    ts: "2023.07 – 2024.08",
    tag: "SHIPPED",
    org: "UF Health // Information Technology Security Analyst",
    body: "Conducted NIST 800-53 aligned security assessments — identified system vulnerabilities and supported compliance efforts. Helped implement security controls that strengthened overall cybersecurity posture. Hands-on with risk management and NIST-aligned strategies. Expanded practical skill set through advanced Palo Alto Firewalls training.",
  },
];

export default function Experience() {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative py-24 lg:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel id="SYS_03">SYSTEM_LOGS // EXPERIENCE</SectionLabel>

        <Reveal>
          <h2 className="font-['Unbounded'] font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F5F5F5] leading-[1.05] max-w-3xl">
            Every role,
            <br />
            <span className="text-[#00FF66]">an evidence file.</span>
          </h2>
        </Reveal>

        <StaggerGroup className="mt-14 border border-white/10 bg-[#0A0A0A]" stagger={0.06}>
          <div className="grid grid-cols-12 border-b border-white/10 px-5 py-3 font-['JetBrains_Mono'] text-[10px] tracking-[0.3em] text-[#A1A1AA]">
            <div className="col-span-4 md:col-span-3">TIMESTAMP</div>
            <div className="col-span-3 md:col-span-2">STATUS</div>
            <div className="col-span-5 md:col-span-7">EVENT</div>
          </div>
          {logs.map((l, i) => (
            <StaggerItem key={i} y={12}>
              <div
                data-testid={`log-row-${i}`}
                className="grid grid-cols-12 gap-2 px-5 py-6 border-b border-white/5 font-['JetBrains_Mono'] text-[13px] hover:bg-white/[0.02] transition-colors"
              >
                <div className="col-span-12 md:col-span-3 text-[#A1A1AA]">
                  {l.ts}
                </div>
                <div className="col-span-12 md:col-span-2 text-[#00FF66]">
                  [{l.tag}]
                </div>
                <div className="col-span-12 md:col-span-7 mt-2 md:mt-0">
                  <div className="text-[#F5F5F5]">{l.org}</div>
                  <div className="text-[#A1A1AA] mt-2 font-['IBM_Plex_Sans'] text-sm leading-relaxed">
                    {l.body}
                  </div>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
